// extracted by mini-css-extract-plugin
export default {"WelcomeText":"SplashPage_WelcomeText__-Z70o","BtnInline":"SplashPage_BtnInline__v6zWP"};